/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import IActiveList from './IActiveList';
import IActiveListItem from './IActiveListItem';

export default abstract class ListComponentBase<T> implements IActiveList<T>
{
    protected abstract items: IActiveListItem<T>[] = [];

    public SyncActiveItems(other: ListComponentBase<T>): ListComponentBase<T>
    {
        for (let item of this.items)
        {
            other.items.find(otherItem => otherItem === item);
        }

        return this;
    }

    public GetActiveItems(): IActiveListItem<T>[]
    {
        return this.items.filter(item => item.Active);
    }

    public HasActiveItems(): boolean
    {
        return this.GetActiveItems().length > 0;
    }

    public Clear(): IActiveList<T>
    {
        this.items.length = 0;
        return this;
    }
}
